// src/pages/IletisimPage.jsx
import React from 'react';
import TopBar from '../components/TopBar';
import NavBar from '../components/NavBar';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

export default function IletisimPage() {
  return (
    <>
      <TopBar />
      <NavBar />
      {/* Tüm şubeleri göster, başlıkları orijinal kalsın */}
      <ContactSection />
      <Footer />
    </>
  );
}
